import { MainResponse } from '../../../main-response.model';
import { SeriesItem } from './series-item.model';


export class ListSeriesResponse extends MainResponse {
    data: SeriesItem[];
 

    constructor(obj = null) {
        super();
        obj = obj || {};
        this.data = [];
        if (obj.object && obj.object instanceof Array) {
            obj.object.forEach((item) => {
                this.data.push(new SeriesItem(item));
            });
        }
    }

}